import React from "react";
import {
  Box,
  Typography,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  ToggleButtonGroup,
  ToggleButton,
} from "@mui/material";
import { DataGridPro } from "@mui/x-data-grid-pro";
import DataGridCustomToolbar from "components/DataGridCustomToolBar";
import EmissionRecordForm from "components/EmissionRecordForm";
import { useEmissionRecordsGrid } from "./hooks/useEmissionRecordsGrid";

export default function EmissionRecords() {
  const {
    backgroundAlt,
    primaryLight,
    rows,
    columns,
    total,
    page,
    setPage,
    pageSize,
    setPageSize,
    sortModel,
    onSortModelChange,
    searchInput,
    setSearchInput,
    setSearch,
    open,
    editMode,
    currentIngredient,
    handleOpen,
    handleClose,
    setOpen,
    columnVisibilityModel,
    setColumnVisibilityModel,
    isSystemAdmin,
    scope,
    setScope,
  } = useEmissionRecordsGrid();

  return (
    <Box p={4}>
      <Box display="flex" justifyContent="space-between" mb={2}>
        <Typography variant="h4">Ingredients & Emission Records</Typography>
        <Box display="flex" gap={2} alignItems="center">
          {!isSystemAdmin && (
            <ToggleButtonGroup
              value={scope}
              exclusive
              onChange={(_, val) => {
                if (val) setScope(val);
              }}
              size="small"
            >
              <ToggleButton value="all">All</ToggleButton>
              <ToggleButton value="org">My org only</ToggleButton>
              <ToggleButton value="system">System</ToggleButton>
            </ToggleButtonGroup>
          )}

          <Button
            variant="contained"
            onClick={handleOpen}
            sx={{ borderRadius: "5px", fontSize: "12px", padding: "5px 10px" }}
          >
            Add Emissions Factor
          </Button>
        </Box>
      </Box>

      <Box
        sx={{
          "& .MuiDataGrid-columnHeaders": { backgroundColor: backgroundAlt },
          "& .MuiDataGrid-virtualScroller": { backgroundColor: backgroundAlt },
          "& .MuiDataGrid-footerContainer": { backgroundColor: primaryLight },
        }}
      >
        <DataGridPro
          rows={rows}
          columns={columns}
          getRowId={(r) => r._id}
          // server pagination
          pagination
          paginationMode="server"
          paginationModel={{ page: page - 1, pageSize }}
          onPaginationModelChange={({ page: gp, pageSize: gs }) => {
            setPage(gp + 1);
            setPageSize(gs);
          }}
          pageSizeOptions={[5, 10, 20, 50, 100]}
          rowCount={total}
          // server sorting
          sortingMode="server"
          sortModel={sortModel}
          onSortModelChange={onSortModelChange}
          columnVisibilityModel={columnVisibilityModel}
          onColumnVisibilityModelChange={(newModel) =>
            setColumnVisibilityModel(newModel)
          }
          // *** v6 toolbar API ***
          slots={{
            toolbar: DataGridCustomToolbar,
          }}
          slotProps={{
            toolbar: {
              searchInput,
              setSearchInput,
              setSearch,
              showSearchBar: true,
              showColumnsButton: true, // we’ll make the toolbar render the columns button
            },
          }}
          disableSelectionOnClick
        />
      </Box>

      <Dialog open={open} onClose={handleClose}>
        <DialogTitle>
          {editMode ? "Edit Emission Record" : "Add Emission Record"}
        </DialogTitle>
        <DialogContent>
          <EmissionRecordForm
            setOpen={setOpen}
            editMode={editMode}
            currentIngredient={currentIngredient}
            handleClose={handleClose}
            open={open}
          />
        </DialogContent>
      </Dialog>
    </Box>
  );
}
